module.exports = __webpack_public_path__ + "static/img/2_3_2.4a606a85.jpg";